import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import FieldModal from 'modules/custom_resources/components/CustomFields/FieldModal'
import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type Field from 'modules/custom_resources/store/models/customResources/Field'

interface Props {
  allowedFieldTypes?: string[]
  allowPermissions?: boolean
  field: Field | CustomField | null | undefined
  showAllowedFieldTypes?: boolean
  showRequired?: boolean
  onClose: () => void
  onSubmit: (data: Record<string, unknown>) => Promise<void>
}

export default function DuplicateModal({
  showAllowedFieldTypes,
  showRequired,
  field,
  onClose,
  onSubmit,
}: Props) {
  return (
    <FieldModal
      modalIllustration="server-edit"
      modalTitle={i18n.t('custom_fields.actions.duplicate.title')}
      modalDescription={i18n.t('custom_fields.actions.duplicate.description')}
      modalLabel={i18n.t('custom_fields.actions.duplicate.label')}
      modalPlaceholder={i18n.t('custom_fields.actions.duplicate.label_placeholder')}
      modalButton={i18n.t('custom_fields.actions.duplicate.submit')}
      allowPermissions={false}
      showAllowedFieldTypes={showAllowedFieldTypes}
      allowedFieldTypes={[
        FieldTypes.text,
        FieldTypes.singleChoice,
        FieldTypes.rating,
        FieldTypes.cents,
      ]}
      field={field}
      duplicate
      showRequired={showRequired}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}
